var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculationMethod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_311_2813)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    stroke: "#222627",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54167 11.5H5.66667V10.3333H4.5V9.45833H5.66667V8.29167H6.54167V9.45833H7.70833V10.3333H6.54167V11.5Z",
    fill: "#222627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.0625H8.58333V10.1875H11.5V11.0625Z",
    fill: "#222627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.60417H8.58333V8.72917H11.5V9.60417Z",
    fill: "#222627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5625 6.36667H4.64583V5.49167H7.5625V6.36667Z",
    fill: "#222627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0417 6.57083L9.225 7.3875L8.6125 6.775L9.42917 5.92917L8.6125 5.1125L9.225 4.5L10.0417 5.31667L10.8583 4.5L11.4708 5.1125L10.6542 5.92917L11.4708 6.775L10.8583 7.3875L10.0417 6.57083Z",
    fill: "#222627"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_2813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculationMethod);
export default __webpack_public_path__ + "static/media/calculation-method.7d5db3568cc7629d289662fc6083713f.svg";
export { ForwardRef as ReactComponent };